const HorizontalLine = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="1091" height="8" viewBox="0 0 1091 8" fill="none">
  <path d="M4 4H1087" stroke="#84BD00" stroke-width="7" stroke-linecap="round"/>
</svg>
    )
}
export default HorizontalLine;